import { EnumSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { PaymentTermTiming } from './payment-term-timing.enum';

export const PaymentTermNetPayloadSchema = z
    .object({
        days: z.number(),
        countFrom: EnumSchema(PaymentTermTiming),
    })
    .strict();

export class PaymentTermNetPayload {
    days: number;
    countFrom: PaymentTermTiming;
}
